import React from 'react';
import '../styles/Radio.css';
import { colour } from '../styles/GlobalStyles';
import { RadioCircle } from '../assets/icons';

function Radio(props) {
    const label = props.label;
    const type = props.type;
    const selected = props.selected;
    const identifier = props.identifier;
    const selectRadio = props.selectRadio;
    return (
        <div 
            className={"radio-container cursor-pointer " + (selected === true ? "" : "radio-container-unselected")}
            onClick={() => selectRadio(identifier)}
        >
            <RadioCircle
                stroke={colour.gray03}
                selected={selected}
                fill={colour.gray06}
            />
            <span className={"colour-primary " + (type === "bold" ? "body-bold" : "body-regular")}>
                {label}
            </span>
        </div>
    )
};

export default Radio;